import { useParams, Link, Navigate } from 'react-router-dom';
import { FullFooter } from '@/components/Footer';
import SubscribeForm from '@/components/SubscribeForm';
import newsletterIssues from '@/data/newsletterIssues';

const NewsletterIssue = ({ showToast, onSubscribe }) => {
  const { slug } = useParams();
  const issue = newsletterIssues.find((i) => i.slug === slug);

  if (!issue) return <Navigate to="/newsletter" replace />;

  // Find prev/next for navigation
  const idx = newsletterIssues.indexOf(issue);
  const prev = newsletterIssues[idx + 1] || null;
  const next = newsletterIssues[idx - 1] || null;

  return (
    <>
      <article className="ni-article">
        <div className="ni-article-inner">
          {/* Breadcrumb */}
          <div className="ni-breadcrumb">
            <Link to="/newsletter">Newsletter</Link>
            <span className="ni-breadcrumb-sep">/</span>
            <span>{issue.num}</span>
          </div>

          {/* Header */}
          <header className="ni-header">
            <span className="ni-issue-label">{issue.num} &middot; {issue.date}</span>
            <h1 className="ni-title">{issue.title}</h1>
          </header>

          {/* Content sections */}
          <div className="ni-body">
            {issue.content.map((section, i) => (
              <section key={i} className="ni-section">
                <h2>{section.heading}</h2>
                <p>{section.text}</p>
              </section>
            ))}
          </div>

          {/* Inline CTA */}
          <div className="ni-inline-cta">
            <p className="ni-cta-label">Get analysis like this every Tuesday.</p>
            <SubscribeForm showToast={showToast} />
          </div>

          {/* Prev / Next navigation */}
          <nav className="ni-nav">
            {prev ? (
              <Link to={`/newsletter/${prev.slug}`} className="ni-nav-link ni-nav-prev">
                <span className="ni-nav-dir">&larr; Previous</span>
                <span className="ni-nav-title">{prev.title}</span>
              </Link>
            ) : <div />}
            {next ? (
              <Link to={`/newsletter/${next.slug}`} className="ni-nav-link ni-nav-next">
                <span className="ni-nav-dir">Next &rarr;</span>
                <span className="ni-nav-title">{next.title}</span>
              </Link>
            ) : <div />}
          </nav>
        </div>
      </article>

      <FullFooter onSubscribe={onSubscribe} />
    </>
  );
};

export default NewsletterIssue;
